import { Icon, type IconProps } from "@chakra-ui/react";
import React from "react";

export function CornerDownRightIcon(props: IconProps) {
  return (
    <Icon width="20px" height="20px" viewBox="0 0 20 20" fill="none" {...props}>
      <path
        d="m12.79 8.62012 4.17 4.16998-4.17 4.17"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3.62012 3.62012v5.83c0 1.83998 1.49 3.32998 3.33 3.32998h9.99998"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Icon>
  );
}
